import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "applyFunctionOrReturn",
})
export class ApplyFunctionOrReturn<T> implements PipeTransform {
  transform(row: T, functionOrValue: unknown | ((row: T) => unknown)): unknown {
    if (functionOrValue && typeof functionOrValue === "function") {
      return functionOrValue(row);
    }
    // if "functionOrValue" is not a function then it is returned
    return functionOrValue;
  }
}
